import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import type { RequestGroup, ServiceRequest } from "@curai/js-fhir-tools";
import { useQueryClient } from "@tanstack/react-query";

interface VoidFailedOrderByTestResponse {
  requestGroup: RequestGroup;
  serviceRequests: ServiceRequest[];
}

interface VoidFailedOrderByTestParams {
  skipPaymentCheck: boolean;
}

export const useVoidFailedOrderByTest = ({
  patientId,
  serviceRequestId,
  encounterId,
}: {
  patientId: string;
  serviceRequestId: string;
  encounterId: string;
}) => {
  const queryClient = useQueryClient();

  return useApiMutation<
    VoidFailedOrderByTestResponse,
    VoidFailedOrderByTestParams
  >({
    mutationOptions: {
      mutationKey:
        QueryKeys.Patient.MedicalRecords.Labs.VOID_FAILED_ORDER_BY_TEST(
          patientId,
          serviceRequestId,
        ),
      mutationFn: ({ skipPaymentCheck }) => {
        return axiosInstance.post(
          `/labs/order/test/${serviceRequestId}/void-failed-order`,
          {
            skipPaymentCheck,
          },
        );
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Labs.DEFAULT(patientId),
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Provider.TASK_LIST_COUNT,
        });
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.Chart.Labs.DEFAULT({
            patientId,
            encounterId,
          }),
        });
      },
    },
  });
};
